module.exports = __webpack_public_path__ + "static/img/190405-bbc-born.c59975e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190405-bbc-born.jpg
// module id = p8T0
// module chunks = 0